module.exports = __webpack_public_path__ + "static/media/signup-info-banner.6822e8c6.svg";